import { cn } from "@/lib/utils";

const Sparkle = () => (
    <svg
        viewBox="0 0 24 24"
        className="h-4 w-4 shrink-0 text-neon-pink"
        fill="currentColor"
        aria-hidden="true"
    >
        <path d="M12 1c.6 5.8 4.2 9.4 10 10-5.8.6-9.4 4.2-10 10-.6-5.8-4.2-9.4-10-10 5.8-.6 9.4-4.2 10-10z" />
    </svg>
);

export default function Marquee({ items, className }) {
    const row = (ariaHidden) => (
        <div
            aria-hidden={ariaHidden || undefined}
            className="flex w-max shrink-0 items-center gap-8 pr-8"
        >
            {items.map((item, i) => (
                <div key={i} className="flex items-center gap-8">
                    <span
                        className={cn(
                            "whitespace-nowrap font-display text-2xl sm:text-3xl font-700 uppercase tracking-wide",
                            i % 2 === 0
                                ? "text-silver"
                                : "text-stroke-silver",
                        )}
                        style={i % 2 === 0 ? { fontWeight: 700 } : undefined}
                    >
                        {item}
                    </span>
                    <Sparkle />
                </div>
            ))}
        </div>
    );

    return (
        <div
            data-testid="marquee-band"
            className={cn(
                "paused-hover relative overflow-hidden border-y border-white/10 bg-coal/60 py-5",
                className,
            )}
        >
            <div className="flex w-max animate-marquee">
                {row(false)}
                {row(true)}
            </div>
        </div>
    );
}
